import { render, staticRenderFns } from "./BlogStore.vue?vue&type=template&id=bddf6dd6&scoped=true&"
import script from "./BlogStore.vue?vue&type=script&lang=js&"
export * from "./BlogStore.vue?vue&type=script&lang=js&"
import style0 from "./BlogStore.vue?vue&type=style&index=0&id=bddf6dd6&scoped=true&lang=css&"
import style1 from "./BlogStore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddf6dd6",
  null
  
)

export default component.exports